export const DownSmallArrowIcon = () => (
  <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.00052 4.66654C4.84476 4.66684 4.6938 4.61259 4.57386 4.51321L0.573858 1.17987C0.290352 0.944232 0.25155 0.52338 0.487191 0.239873C0.722833 -0.0436327 1.14368 -0.0824347 1.42719 0.153207L5.00052 3.13987L8.57386 0.259873C8.71159 0.148026 8.88822 0.0956942 9.06465 0.114463C9.24107 0.133232 9.40274 0.221554 9.51386 0.359873C9.63728 0.498446 9.69736 0.682192 9.67965 0.866913C9.66193 1.05163 9.56803 1.22061 9.42052 1.33321L5.42052 4.55321C5.29713 4.63688 5.14926 4.67679 5.00052 4.66654Z"
      fill="#212B36"
    />
  </svg>
);
